import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61143db5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "report__header-top" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-external-link-alt" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "filename" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "report__header-info" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["v-if", "href"]
const _hoisted_23 = {
  key: 0,
  class: "report-details"
}
const _hoisted_24 = { class: "icon" }
const _hoisted_25 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_26 = {
  key: 1,
  class: "fas fa-times"
}
const _hoisted_27 = { class: "test-name" }
const _hoisted_28 = { class: "test-result" }
const _hoisted_29 = { class: "spec" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    id: $data.report.id,
    class: _normalizeClass(["report", $options.reportClassModifier])
  }, [
    _createElementVNode("div", {
      class: "report__header",
      onClick: _cache[2] || (_cache[2] = $event => ($data.showDetails = !$data.showDetails))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("span", null, [
            _createElementVNode("a", {
              class: "file-link-icon",
              href: $data.report.url,
              target: "_blank",
              title: "preview",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, _hoisted_5, 8, _hoisted_3),
            _createElementVNode("span", _hoisted_6, _toDisplayString($props.creativeData.name), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_7, _toDisplayString($options.overviewStatus), 1),
          _createElementVNode("span", _hoisted_8, [
            ($options.isBusy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
              : ($data.showDetails)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14))
                : (!$data.showDetails)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17))
                  : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createTextVNode(_toDisplayString($options.hostingPartner) + " " + _toDisplayString($options.creativeType) + " • " + _toDisplayString($options.creativeDimensions) + " • " + _toDisplayString($options.creativeTimestamp) + "   ", 1),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = (...args) => (this.deleteObject && this.deleteObject(...args)))
        }, _hoisted_20)
      ]),
      ($data.report.queryPath !== null)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: $data.delightHouse + $data.report.queryPath,
            style: {"display":"none"}
          }, null, 8, _hoisted_21))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        "v-if": $data.report.fullReport && $data.report.fullReport.length,
        href: $data.report.fullReport,
        style: {"display":"none"}
      }, null, 8, _hoisted_22)
    ]),
    ($options.validations.length > 0 && $data.showDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.validations, ({ testId, valid, testName, testResult, spec }) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: testId,
                  class: _normalizeClass(valid ? 'valid' : 'error')
                }, [
                  _createElementVNode("td", _hoisted_24, [
                    valid
                      ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                      : (_openBlock(), _createElementBlock("i", _hoisted_26))
                  ]),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(testName), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(testResult), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString(spec), 1)
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}